import BookIconSvg from 'assets/images/icons/book.svg?react';
import CalendarIconSvg from 'assets/images/icons/calendar.svg?react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PropertyBusinessType } from 'models/Properties';
import { StackedCalendarMode } from 'pages/stackedCalendar/Calendar.types';
import { calendarModeLocalStorageKey } from 'pages/stackedCalendar/Calendar.constants';
import usePropertyGuidebookLink from '../usePropertyGuidebookLink';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import { HeaderContainer } from '../common/header/CommonHeader.styles';
import AddUnitTypeButton from '../common/header/AddUnitTypeButton';
import HeaderIconButton from '../common/header/HeaderIconButton';

const PropertySettingsPricingTabHeader = () => {
  const { t } = useTranslation();
  const { uid: propertyUid } = useParams();
  // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const guidebookLink = usePropertyGuidebookLink(propertyUid);
  const { property } = usePropertySettingsInitData();

  if (property?.businessType === PropertyBusinessType.HOTEL) {
    return (
      <HeaderContainer>
        <AddUnitTypeButton />
      </HeaderContainer>
    );
  }

  const redirectToCalendarPricing = () => {
    localStorage.setItem(
      calendarModeLocalStorageKey,
      StackedCalendarMode.PRICING,
    );
  };

  return (
    <HeaderContainer>
      <HeaderIconButton
        id="calendar-link"
        text={t('pageProperty.mainSettings.header.calendar')}
        href={`/calendar?propertyUid=${propertyUid}`}
        onClick={redirectToCalendarPricing}
        icon={<CalendarIconSvg />}
      />

      {!!guidebookLink && (
        <HeaderIconButton
          id="guidebook-link"
          text={t('pageProperty.mainSettings.header.guidebook')}
          href={guidebookLink}
          icon={<BookIconSvg />}
        />
      )}
    </HeaderContainer>
  );
};

export default PropertySettingsPricingTabHeader;
